import { render } from "./VF-inputText.vue?vue&type=template&id=afb46f4e"
import script from "./VF-inputText.vue?vue&type=script&lang=js"
export * from "./VF-inputText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__